import _ from 'lodash';
import {SystemError} from '../model/model';

const operationModes = [
    'normal', 'fallback', 'screenOff'
];

export class appModelService {
  constructor($q, APIConfig, persistent, utils) {
    "ngInject";
    this.$q = $q;
    this.APIConfig = APIConfig;
    this.persistent = persistent;
    this.utils = utils;

    this.uoid = null;
    this.username = null;
    this.password = null;
    this.stylesheetReferences = [];
    this.articles = [];
    /* Error log. Dump of all errors. */
    this.errorLog = [];

    /* No usage for now. */
    this.userInfo = null;
    this.systemInfo = null;

    /* A global error flag for errors anywhere in the application. The flag is
      cleared at the start of the polling cycle. If any error is detected during the cycle, the errorFlag
      is raised. At the end of the cycle, the application checks whether the errorFlag
      is set and if so, enters fallback modus.
     */
    this.errorsPendingFlag = false;
    /* errorFlag directly influences the operation mode.
       At the end of the cycle, errorsPendingFlag is copied to errorFlag. */
    this.errorFlag = false;
    /* normal, fallback, screenOff */
    this.systemOperationMode = 'normal';
  }

  setCredentials(username, password, uoid, token) {
    this.username = username;
    this.authString = token ? null : btoa(`${username}:${password}`);
    this.uoid = uoid;
    this.token = token;
  }

  setDebugMode(mode) {
    this.debugOn = mode === 'on';
  }

  /**
    Set the operation mode.
  **/
  setOperationMode(mode) {
    /* Check if we have a valid mode. */
    if (operationModes.indexOf(mode) !== -1) {
      this.systemOperationMode = mode;
    } else {
      console.debug(`Invalid operation mode: ${mode}`);
    }
  }

  /* The operation is defined by the operator, but is overruled by the system
   * state is the system is BLOCKING.
   */
  getAggregatedOperationMode() {
    let mode;

    if (this.errorFlag) {
      mode = 'fallback';
    } else {
      mode = this.systemOperationMode;
    }
    return mode;
  }

  setLoginInfo(info) {
    /* Sanity check: check if info contains user and system information. */
    if (info && typeof info.userInfo === 'object' && typeof info.systemInfo === 'object') {
      this.userInfo = info.userInfo;
      this.systemInfo = info.systemInfo;

      this.persistent.setItem('userInfo', info.userInfo);
      this.persistent.setItem('systemInfo', info.systemInfo);
    } else {
      /* Try to get the info from local storage */
      this.userInfo = this.persistent.getItem('userInfo');
      this.systemInfo = this.persistent.getItem('systemInfo');
      if (!this.userInfo || !this.systemInfo) {
        this.setError('app-model.services:setLoginInfo()', this.APIConfig.error.RECEIVED_INCORRECT_DATA_FORMAT, this.APIConfig.errorLevel.BLOCKING);
      }
    }
  }

  setSystemInfo(info) {
    this.systemInfo = info;
  }

  clearSystemInfo() {
    this.systemInfo = null;
  }

  clearPendingErrors() {
    this.pendingErrorFlag = false;
  }

  processPendingErrors() {
    this.errorFlag = this.pendingErrorFlag;
  }

  setError(origin, type, level) {
    level = level || this.APIConfig.errorLevel.WARNING;
    /* FIFO buffer */
    if (this.errorLog.length > this.APIConfig.maxErrorLogLength) {
      const start = this.errorLog.length - this.APIConfig.maxErrorLogLength;
      this.errorLog.slice(start);
    }
    this.errorLog.push(new SystemError(type, origin, level));

    if (level === this.APIConfig.errorLevel.BLOCKING) {
      this.pendingErrorFlag = true;
    }
  }

  // clearError(origin, type) {
  //   const key = `${origin}|${type}`;
  //   _.pull(this.activeErrors, key);
  // }
  /**
  * reference = { id:<id>, url: <url>, lastUpdate: <timestamp> }
  **/
  addStylesheetReference(reference) {
    /* For now, just remove it, ignoring lastUpdate. */
    _.remove(this.stylesheetReferences, {id: reference.id});
    this.stylesheetReferences.push(reference);
  }

  getUnfetchedArticleIds(articleListItems) {
    const unfetched = [];
    articleListItems.forEach(articleListItem => {
      /* Try to find an article that has the same id and is from the same or later date. */
      const matchingArticle = _.find(this.articles, article => {
        return article.id === articleListItem.id &&
          this.utils.isSameOrLater(articleListItem.__lastUpdate, article.__lastUpdate);
        });

      if (!matchingArticle) {
        /* There is no article with the same id, or an article with the same id
        * is older.
        */
        unfetched.push(articleListItem.id);
      }
    });
    return unfetched;
  }

  getArticles(ids) {
    return this.articles.filter(article => ids.indexOf(article.id) !== -1);
  }

  /* Add or replace articles based on id and lastUpdate.
   * This function only changes the cache. Removing an article from cache has
   * no direct influence on the display of that article.
   */
  addArticles(articles) {
    articles.forEach(newArticle => {
      const matchingArticle = _.find(this.articles, {id: newArticle.id});
      if (matchingArticle) {
        /* Only replace if the new article is from a later date. */
        if (this.utils.isLater(matchingArticle.__lastUpdate, newArticle.__lastUpdate)) {
          _.remove(this.articles, {id: newArticle.id});
          this.articles.push(newArticle);
        }
      } else {
        this.articles.push(newArticle);
      }
    });

    /* Remove expired articles, based on their validity. */
    _.remove(this.articles, article => this.utils.isLater(article.__validity.to));
  }

  /* Check for each ArticleListItem if the cached version is older. If so,
   * remove the cached item.
   * @param articleList Array of ArticleListItem
   */
  removeUpdatedArticles(articleList) {
      articleList.forEach(item => {
        _.remove(this.articles, article => this.utils.isLater(article.__lastUpdate, item.__lastUpdate))
      })
  }

  removeUnreferencedArticles(referencedArticleIds) {
    this.articles = this.articles.filter(article => referencedArticleIds.indexOf(article.id) !== -1);
  }
}



// WEBPACK FOOTER //
// ./client/app/services/app-model.services.js